export const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export function isValidEmail(value) {
    if (value == null || value === "") return true; // optional
    return EMAIL_RE.test(value.trim());
}

export function sanitizeText(value) {
    if (value == null) return "";
    return String(value)
        .replace(/<[^>]*>/g, "") // strip any HTML tags
        .slice(0, 2000);
}
